module.exports = __webpack_public_path__ + "static/media/11.ffff9d06.jpg";